<template lang="pug">
include ../../../prototype/src/pug/abstracts/variables
include ../../../prototype/src/pug/abstracts/mixin.pug
.footer__wrapper
	.footer__inner
		.footer__column
			.footer__title Canais de contato
			ul.footer__links
				FooterNavigationItem(label="Benefícios", id="beneficios", navigationToken="beneficios")
				FooterNavigationItem(label="Certificados", id="certificados", navigationToken="certificados")
				FooterNavigationItem(label="Suporte", id="precisa_de_ajuda", navigationToken="precisa_de_ajuda")
				FooterNavigationItem(label="Postos de Atendimento", id="posto_de_atendimento", navigationToken="posto_de_atendimento")
				li(class="footer__link")
					a(href="/uploads/hotsite_certificado_digital/politica_de_garantia_do_certificado_digital.pdf" target="_blank") Políticas de garantia
				li(class="footer__link")
					a(href="/uploads/hotsite_certificado_digital/politica_de_arrependimento_do_certificado_digital.pdf" target="_blank") Políticas de arrependimento
		a(href="#topo").footer__arrow
			+i('icon_topdown.svg')
</template>


<script>
import FooterNavigationItem from "@/components/navigation/FooterNavigationItem.vue";

export default {
	name: "Footer",
	components: {
		FooterNavigationItem
	}
}
</script>